import { buildDarkwingFacilityRelativePath } from '@/components/navigation/utils';

export const LOCAL_OFFLINE_AGENT_PORT = 8080;

type OfflineLocation = Pick<Location, 'protocol' | 'hostname'>;

const offlineBase = (location: OfflineLocation): string =>
  `${location.protocol}//${location.hostname}:${LOCAL_OFFLINE_AGENT_PORT}`;

/**
 * Builds the local offline agent URL for a facility.
 *
 * Offline localproxy serves Darkwing only on port 8080 at the facility root path.
 */
export function buildOfflineRedirectUrl(
  location: OfflineLocation,
  orgName: string,
  facilityName: string
): string {
  return `${offlineBase(location)}/${buildDarkwingFacilityRelativePath(orgName, facilityName)}`;
}

/**
 * Disconnect from AgentProxy by redirecting to the local offline agent URL.
 *
 * Preserves the current page protocol (Darkwing parity): local online mode often
 * reaches cloudproxy over HTTP on port 80, and localproxy serves HTTP on 8080.
 */
export function goOffline(allowed: boolean, orgName?: string, facilityName?: string): void {
  if (!allowed) return;

  if (orgName && facilityName) {
    window.location.href = buildOfflineRedirectUrl(window.location, orgName, facilityName);
    return;
  }

  window.location.href = offlineBase(window.location);
}
